<template>
    <div class="subtopic-content">
        <div class="header">
            <div class="icon-circle">
                <AssetsImg :asset-path="subtopicIconSrc" alt="subtopic icon" class="icon" />
            </div>
            <h2 class="title">
                {{ subtopicTitle }}
            </h2>
        </div>
        <ContentBox v-for="(item, index) in subtopicData" v-bind:key="index">
            <p v-if="item.text !== ''" class="first" v-html="item.text"></p>
            <br v-if="item.text !== '' && item.picSrc !== undefined" />
            <AssetsImg
                v-if="item.picSrc !== undefined"
                :asset-path="item.picSrc"
                alt="pic"
                class="image"
            />
            <p class="caption" v-if="item.caption !== undefined" v-html="item.caption"></p>

            <div v-if="item.picList !== undefined">
                <div v-for="(picItem, i) in item.picList" v-bind:key="999 + i">
                    <AssetsImg
                        v-if="picItem.picSrc !== undefined"
                        :asset-path="picItem.picSrc"
                        alt="pic"
                        class="image"
                    />
                    <p class="caption">
                        {{ picItem.caption }}
                        <br /><br />
                    </p>
                </div>
            </div>
        </ContentBox>
    </div>
</template>

<script>
    import AssetsImg from '@/components/AssetsImg';
    import ContentBox from '@/components/ContentBox';

    export default {
        name: 'SubtopicContent',
        components: {
            ContentBox,
            AssetsImg,
        },
        props: {
            subtopicIconSrc: String,
            subtopicTitle: String,
            subtopicData: Array,
        },
        data: function () {
            return {};
        },
        methods: {},
    };
</script>

<style lang="scss">
    .subtopic-content {
        width: 100%;
        margin-bottom: 50px;

        .header {
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;

            h2 {
                font-size: 26px;
            }

            .icon-circle {
                display: flex;
                justify-content: center;
                align-items: center;

                width: 100px;
                height: 100px;
                border-radius: 50%;
                background-color: $gold;
            }

            .icon {
                width: 45px;
            }
        }

        .image {
            width: 100%;
        }

        .caption {
            text-align: center;
        }
    }
</style>
